export default __webpack_public_path__ + "static/media/what-we-provide-security-icon.e2c39703.svg";